import { Store } from "./store";
import getContent, { SUPPORTED_LANGUAGE, defaultContent } from "../content";
import getInterface, { defaultInterface } from "../texts";
import { Core } from "./core";
import { createWrapper } from "@upandgo/scorm-wrapper";
import { getNavigatorCompatibleLanguage } from "../utils";

export const store = new Store(
  defaultContent.language as typeof SUPPORTED_LANGUAGE[number],
  defaultContent,
  defaultInterface,
);
export const core = new Core(
  store,
  createWrapper,
  getContent,
  getInterface,
  getNavigatorCompatibleLanguage,
  SUPPORTED_LANGUAGE,
  defaultContent,
);
